import React from 'react';
import { isEmpty } from 'lodash';
import Icons from '../layouts/Icons';

export default function ContactUsDetails({ data }) {
  const { cardsList } = data;
  return (
    <div className="w-auto flex flex-col lg:gap-y-[55px] gap-y-[30px]">
      {isEmpty(cardsList) ||
        cardsList.map((card, index) => (
          <div className="flex flex-col lg:gap-y-[28px] gap-y-[7px]" key={index}>
            <h3
              className="uppercase font-roboto-condensed-bold text-[23px] leading-[46px]
            text-bg-3"
            >
              {card.content.title}
            </h3>
            <div>
              <div
                className="li-child:text-bg-3 li-child:font-roboto-regular li-child:3xl:text-base
                  li-child:lg:text-[14px] li-child:!text-base li-child:leading-7
                  first:li-child:w-1/5 first:li-child:min-w-[3.5rem] li-child:truncate
                  ul-child:flex ul-child:flex-nowrap ul-child:gap-x-4 ul-child:gap-y-2
                  p-child:text-bg-3 p-child:font-roboto-regular p-child:3xl:text-base
                  p-child:lg:text-[14px] p-child:text-base p-child:leading-7 "
                dangerouslySetInnerHTML={{ __html: card.content.infoText }}
              />
              {isEmpty(card.content.instagram) || (
                <div className="flex items-center lg:gap-x-4 lg:pt-[5px] pt-2">
                  <p
                    className="3xl:text-base lg:text-[14px] text-base leading-7 font-roboto-regular
                  text-bg-3 w-[23%]"
                  >
                    Social:
                  </p>
                  <div className="flex gap-x-[18px]">
                    {isEmpty(card.content.instagram) || (
                      <a
                        href={card.content.instagram}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="instagram"
                        className="w-[24px] h-[24px] instagram"
                      >
                        <Icons icon="instagram" className="svg-child:fill-black" />
                      </a>
                    )}
                    {isEmpty(card.content.facebook) || (
                      <a
                        href={card.content.facebook}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="facebook"
                        className="w-[24px] h-[24px] facebook"
                      >
                        <Icons icon="facebook" className="svg-child:fill-black" />
                      </a>
                    )}
                    {isEmpty(card.content.youtube) || (
                      <a
                        href={card.content.youtube}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="youtube"
                        className="w-[24px] h-[24px] youtube"
                      >
                        <Icons icon="youtube" 
                        className="svg-child:fill-black svg-child2:!fill-black" />
                      </a>
                    )}
                    {isEmpty(card.content.twitter) || (
                      <a
                        href={card.content.twitter}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="twitter"
                        className="w-[24px] h-[24px] twitter"
                      >
                        <Icons
                          icon="twitter"
                          className="svg-child:fill-black svg-child2:!fill-black"
                        />
                      </a>
                    )}
                    {isEmpty(card.content.tiktok) || (
                      <a
                        href={card.content.tiktok}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="tiktok"
                        className="w-[24px] h-[24px] tiktok"
                      >
                        <Icons
                          icon="tiktok"
                          className="svg-child:fill-black svg-child2:!fill-black"
                        />
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}
